import { TValidTestId } from 'types/context-role-element.types';
import { CONTEXT, ELEMENT, ROLE } from '../../context-role-element';

export default {
  [CONTEXT.HEADER]: {
    [ROLE.CONTAINER]: [ELEMENT.ZIPCODE_POPUP],
  },
} as TValidTestId;
